import React, { useEffect, useState } from "react";
import { TrendingUp, TrendingDown } from "lucide-react";
import { fetchMarketIndices } from "../api";

const MarketTicker = () => {
  const [indices, setIndices] = useState([]);

  useEffect(() => {
    fetchMarketIndices()
      .then(setIndices)
      .catch(() => setIndices([]));
  }, []);

  if (indices.length === 0) return null;
  const items = [...indices, ...indices];

  return (
    <div className="bg-sq-navy text-white overflow-hidden border-b border-white/10">
      <div className="max-w-7xl mx-auto relative">
        <div className="flex items-center whitespace-nowrap animate-[ticker_30s_linear_infinite] py-2">
          {items.map((it, i) => (
            <div key={i} className="flex items-center gap-2 px-6 text-sm">
              <span className="font-medium">{it.name}</span>
              <span className="text-gray-300">{it.value}</span>
              <span
                className={`flex items-center gap-0.5 font-semibold ${
                  it.up ? "text-emerald-400" : "text-red-400"
                }`}
              >
                {it.up ? <TrendingUp size={13} /> : <TrendingDown size={13} />}
                {it.change}
              </span>
            </div>
          ))}
        </div>
      </div>
      <style>{`@keyframes ticker {0%{transform:translateX(0)}100%{transform:translateX(-50%)}}`}</style>
    </div>
  );
};

export default MarketTicker;
